import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreakpointService } from './services/breakpoint-observer.service';

@Component({
  selector: 'fb-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(private breakpointService: BreakpointService) {
    this.breakpointService.initListener();
  }
}
